/* eslint-disable indent */
import { ModelTypeEnum } from 'modules/environments/interfaces';
import { getFieldStateKeyByProvider } from '../cloudProviderUtils';
import { LICENSE_TYPE_NOT_DEFINED_OPTION } from '../licenseTypeDisplay';
import { GenericFormItemWithLoadingKey } from '../utils';

const getLoadingKeyByProvider = (providerType = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.customImage]: 'isLoadingImages',
    [ModelTypeEnum.bootVolume]: 'isLoadingBootVolumes',
    [ModelTypeEnum.bootVolumeBackup]: 'isLoadingBootVolumeBackups',
  }[providerType]);

const ociFields = (
  providerType = ModelTypeEnum.customImage,
  {
    isEdit = false,
    isSuperAdmin = false,
  }: { isEdit?: boolean; isSuperAdmin?: boolean } = {}
): GenericFormItemWithLoadingKey[] => [
  {
    gridXs: 12,
    label: `${providerType?.toUpperCase()}_KEY`,
    stateKey: getFieldStateKeyByProvider(providerType),
    isSelect: true,
    options: [],
    isLoadingKey: getLoadingKeyByProvider(providerType),
  },
  {
    gridXs: 6,
    label: 'Subnet',
    stateKey: 'provider_data.subnet',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingSubnets',
  },
  {
    gridXs: 6,
    label: 'FLAVOR_KEY',
    stateKey: 'provider_data.flavor',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingFlavors',
  },
  {
    gridXs: 6,
    label: 'ZONE_KEY',
    stateKey: 'provider_data.zone',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingZones',
  },
  {
    gridXs: 6,
    label: 'SECURITY_GROUP_KEY',
    stateKey: 'provider_data.security_group',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingSecurityGroups',
  },
  {
    gridXs: 6,
    label: 'LICENSE_TYPE_KEY',
    stateKey: 'provider_data.license_type',
    ...(isEdit
      ? {
          isSelect: true,
          selectCantBeNull: true,
          options: [
            {
              value: LICENSE_TYPE_NOT_DEFINED_OPTION,
              label: 'LICENSE_TYPE_NOT_DEFINED_KEY',
            },
            {
              value: 'BRING_YOUR_OWN_LICENSE',
              label: 'LICENSE_TYPE_BRING_YOUR_OWN_KEY',
            },
            { value: 'OCI_PROVIDED', label: 'LICENSE_TYPE_OCI_PROVIDED_KEY' },
          ],
          disabled: !isSuperAdmin,
        }
      : { disabled: true }),
  },
];

export default ociFields;
